import React from 'react';
import TitleView from './titleview';
import ImageOption from './imageoption';
import _ from 'lodash';
import howManyColumns from '../utils/howmanycolumns';

class MultiChoiceImages extends React.Component {
	constructor(props) {
		super(props);

		this.state = {

		};

		this.onSelectOption = this.onSelectOption.bind(this);
		this.onWindowResize = this.onWindowResize.bind(this);
	}

	onSelectOption(option) {
		const question = this.props.question;
		const answer = this.props.answer;

		if (question.multi_answer) {
			if (_.includes(answer.multi_question_options_answer_ids, option.id)) {
				answer.multi_question_options_answer_ids = _.without(answer.multi_question_options_answer_ids, option.id);
			} else {
				answer.multi_question_options_answer_ids.push(option.id);
			}
		} else {
			answer.question_option_id = option.id;
		}

		this.props.onChangeAnswer(answer);
	}

	onWindowResize() {
		this.forceUpdate();
	}

	componentDidMount() {
    window.addEventListener("resize", this.onWindowResize);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.onWindowResize);
	}

	_renderOption(op, index) {
		const answer = this.props.answer;
		const question = this.props.question;

		let checked;
		if (question.multi_answer) {
			checked = _.includes(answer.multi_question_options_answer_ids, op.id);
		} else {
			checked = answer.question_option_id === op.id;
		}

		const results = howManyColumns({
			containerWidth: window.innerWidth,
			idealContainerWidth: 375,
			idealColumns: 2,
			left: 14,
			right: 14,
			interItem: 10,
			roundDown: true
		});

		const lastItemInRow = index % results.columns == results.columns - 1;

		return (
			<div style={{
				marginRight: lastItemInRow ? 0 : 10,
				marginTop: 10
			}} key={index}>
				<ImageOption 
				width={results.columnWidth} 
				height={results.columnWidth} 
				src={op.image_url} 
				title={op.option_text} 
				checked={checked} 
				onClick={this.onSelectOption.bind(this, op)}/>
			</div>);
	}

	render() {
		const question = this.props.question;

		const items = question.question_options.map((op, index) => {
			return this._renderOption(op, index);
		});

		return (
			<div>
				<TitleView title={question.question_text}/>
				<div style={{
					display: 'flex',
					paddingLeft: 14,
					flexWrap: 'wrap'
				}}>
					{items}
				</div>
			</div>
		);
	}
}

export default MultiChoiceImages;


// WEBPACK FOOTER //
// ./src/components/multichoiceimages.jsx